import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ExperienceTracker } from '@atlassian/experience-tracker';
import { isAuthError, isErrorStatusCode, StatusCode } from './utils';
export class TeamsExperienceTracker extends ExperienceTracker {
  _errorNameInIgnoredList(error) {
    const name = error && error.constructor.name;
    return this._ignoredErrors.includes(name) ? name : undefined;
  }
  constructor(options) {
    super(options);
    // error names here will also be sent in the attribute `cause`
    _defineProperty(this, "_ignoredErrors", ['SentryIgnoreError']);
  }
  stopOnError({
    name,
    error
  }) {
    if (isAuthError(error)) {
      this.abort({
        name,
        reason: 'Abort due to user unauthenticated',
        attributes: {
          cause: 'USER_UNAUTHENTICATED',
          error
        },
        checkForTimeout: false
      });
      return;
    }
    if (isErrorStatusCode(StatusCode.GONE, error)) {
      this.abort({
        name,
        reason: 'Abort due to unavailable resource',
        attributes: {
          cause: 'GONE',
          error
        },
        checkForTimeout: false
      });
      return;
    }
    const ignoredErrorName = this._errorNameInIgnoredList(error);
    if (ignoredErrorName) {
      this.abort({
        name,
        reason: 'Abort due to an error in ignore list',
        attributes: {
          cause: ignoredErrorName
        },
        checkForTimeout: false
      });
      return;
    }
    super.stopOnError({
      name,
      error
    });
  }
}